import { useEffect, useState } from 'react'
import { DataType } from '../../../../../tables'
import { usePurchasesHooks, usePurchasesState } from '../../../hooks/purchasesHooks'
import { FieldType, FieldValue, option, FilterField, Filters, O } from '../../../../../features/ui'
import { useManagerState } from '../../../../manager'
import { PurchaseOrder } from '../../../state/types'
import { Labels } from '../../../../../features/data-types'
import { DeliveryStatus } from '../../../../deliveries'

type Props = {
    purchases: PurchaseOrder[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'purchase'

export const PurchaseFilters = (props: Props) => {
    const { purchases, onSearchStart, onSearchDone } = props

    const purchasesState = usePurchasesState()
    const suppliers = purchasesState.suppliers
    const { currentBranch } = useManagerState()
    const currentBranchId = currentBranch!.id

    const [searchText, setSearchText] = useState<string>()
    const [deliveryStatus, setDeliveryStatus] = useState<DeliveryStatus>()
    const [supplierId, setSupplierId] = useState<string>()

    const { searchPurchases } = usePurchasesHooks()

    useEffect(() => {
        search(searchText, deliveryStatus, supplierId)
    }, [purchases])

    const search = (
        searchTextParam?: string,
        deliveryStatusParam?: string,
        supplierIdParam?: string
    ) => {
        onSearchStart()
        let purchaseList = purchases.filter(purchase => purchase.deliveryBranchId === currentBranchId)
        purchaseList = purchaseList.filter(purchase => !deliveryStatusParam || purchase.deliveryStatus === deliveryStatusParam)
        purchaseList = purchaseList.filter(purchase => !supplierIdParam || purchase.supplierId === supplierIdParam)
        purchaseList = searchPurchases(purchaseList, searchTextParam)
        setTimeout(() => onSearchDone(purchaseList), 100)
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText, deliveryStatus, supplierId)
    }

    const onChangeDeliveryStatus = (value?: FieldValue) => {
        const newDeliveryStatus = value as O<DeliveryStatus>
        if (newDeliveryStatus !== deliveryStatus) {
            setDeliveryStatus(newDeliveryStatus)
            search(searchText, newDeliveryStatus, supplierId)
        }
    }

    const onChangeSupplier = (value?: FieldValue) => {
        const newSupplierId = value as O<string>
        if (newSupplierId !== supplierId) {
            setSupplierId(newSupplierId)
            search(searchText, deliveryStatus, newSupplierId)
        }
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por código o proveedor',
        icon: 'search',
        onChange: handleSearch
    }

    const filterFields: FilterField[] = [
        {
            name: 'deliveryStatus',
            type: FieldType.SELECT,
            options: Object.values(DeliveryStatus).map(status => option(status, Labels.deliveryStatusLabel(status))),
            label: 'Estado de Entrega',
            space: 3,
            onChange: onChangeDeliveryStatus
        },
        {
            name: 'supplier',
            type: FieldType.SELECT,
            options: suppliers.map(supplier => option(supplier.id, supplier.name)),
            label: 'Proveedor',
            onChange: onChangeSupplier
        }
    ]

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
            fields={filterFields}
        />
    )
}
